import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.ts'
import './assets/css/icon.css'
import '@/utils/filter'
import {loadClassifyTree} from '@/store/classifyStore'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

loadClassifyTree()

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

